<template>
    <v-container style="max-width:calc(100% - 50px);">
            <v-btn v-if="currentClient!=undefined" @click="note_dialog=true" top color="#e12826" dark fab fixed class="mx-4 my-2 elevation-0">
                <v-icon color="white">  mdi-notebook-edit-outline </v-icon>
            </v-btn> 
        <v-tabs right v-model="tab" color="red" style="font-family:Oswald;">
            <v-tab v-if="currentUser.id == 1">Toma de medidas</v-tab>
            <v-tab v-if="currentUser.id == 1">Planes Alimenticios</v-tab>
            <v-tab>Plan de Entrenamiento</v-tab>
            <v-tab v-if="currentUser.id == 1">Calculo Dietetico</v-tab>
            <v-tab v-if="currentUser.id == 1">Habitos Saludables</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item v-if="currentUser.id == 1">
                <v-card flat>
                    <measurements/>
                </v-card>
            </v-tab-item>
            <v-tab-item v-if="currentUser.id == 1">
                <v-card flat>
                    <meal-plans/>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat>
                    <training/>
                </v-card>
            </v-tab-item>
            <v-tab-item v-if="currentUser.id == 1">
                <v-card flat>
                    <diet-calc/>
                </v-card>
            </v-tab-item>
            <v-tab-item v-if="currentUser.id == 1">
                <v-card flat>
                    <habits/>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
        <v-dialog v-if="currentClient!=undefined" v-model="note_dialog" max-width="700px">
            <v-card class="pa-6">
                <v-card-title class="ma-0 pa-0 mb-2">Nota</v-card-title>
                <v-textarea outlined v-model="currentClient.note"></v-textarea>
                <v-row class="ma-0">
                    <v-spacer/>
                    <v-btn class="elevation-0" :loading="gris" @click="save()" dark color="#e12826">Guardar</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import Measurements from "../../measurements/container.vue"
import MealPlans from "../../meal_plans/container.vue"
import Training from "../../training/container.vue"
import DietCalc from "../../diet/calc.vue"
import Habits from "../../habits/container.vue"
import axios from "axios"
export default {
    components:{
        'measurements':Measurements,
        'meal-plans':MealPlans,
        'training':Training,
        'diet-calc': DietCalc,
        'habits':Habits
    },
    data(){
        return{
            tab: null,
            note_dialog:false,
            currentClient:{},
            gris:false,
        }
    },
    methods:{
        save(){
            this.gris = true
            axios.patch(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/users/" + this.currentClient.id, {note:this.currentClient.note}).then(response=>{
                this.gris = false
            })
        },
        confirmExit(event) {
            const isDirty = localStorage.getItem('isDirty')
            if (isDirty) {
                event.returnValue = '¿Estás seguro de que deseas salir? Se perderán los cambios no guardados.';
            }
        }
    },
    created(){
        localStorage.removeItem('isDirty')
        axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/users/" + this.user_id).then(res => {
            this.currentClient = res.data.data
        })
    },
    mounted(){
        localStorage.removeItem('isDirty')
        window.addEventListener('beforeunload', this.confirmExit);
        
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.confirmExit);
    },
    beforeRouteLeave(to, from, next) {
        const isDirty = localStorage.getItem('isDirty')
        if (isDirty) {
            if (confirm('¿Estás seguro de que deseas salir? Se perderán los cambios no guardados.')) {
                next();
            }else {
                next(false);
            }
        }else {
            next();
        }
    },
    computed:{
        user_id(){
            return this.$route.params.id
        },
        currentUser:{
            get(){
                return this.$store.state.currentUser.user;
            }
        },
    },
    watch:{
        user_id:{
            handler(){
                axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/users/" + this.user_id).then(res => {
                    this.currentClient = res.data.data
                })
            }, deep: true
        }
    }
}
</script>